'use client';

import { useDebounceValue } from 'usehooks-ts';
import { useState, useRef } from 'react';
import { useListProductSuggestionsQuery } from '@/modules/products';

const useAutoComplete = (defaultValue?: string) => {
	const [ value, setValue ] = useState(defaultValue ?? '');
	const [ debouncedValue ] = useDebounceValue(value, 300);
	const isDebouncing = value !== debouncedValue;
	const [ showSuggestions, setShowSuggestions ] = useState(false);
	const wrapperRef = useRef(null);

	const { data, isLoading } = useListProductSuggestionsQuery(debouncedValue);

	const suggestions = data ?? [];

	const showMessage = debouncedValue.length > 0 && debouncedValue.length < 3 && !isLoading;

	return {
		isDebouncing,
		wrapperRef,
		value,
		setValue,
		suggestions,
		isLoading,
		showSuggestions,
		setShowSuggestions,
		showMessage,
	};
};

export default useAutoComplete;